'use client';

import { Box, Link, Typography } from '@mui/material';
import type React from 'react';
import { useEffect, useMemo } from 'react';
import { CITATION_LIST_ID } from '../../../CitationList/constants';
import { DisclosureTooltip } from '../../../DisclosureTooltip';
import { type ICitation, useCitationContext } from './context';

export const Citation = (props: ICitation): React.JSX.Element | null => {
  const { registerCitation, unregisterCitation, scrollToCitationList } = useCitationContext();
  const citation = useMemo(() => registerCitation(props), [props]);
  const { citationNumber, publication, url, title, accessDateFormatted, showInline, id } = citation;

  useEffect(() => {
    return () => {
      unregisterCitation(citation);
    };
  }, [citation]);

  // If this is an inline citation, we should not display
  // any UI for it. It will only appear in the CitationList
  if (!showInline) {
    return null;
  }

  return (
    <DisclosureTooltip
      trigger={toggle => (
        <Link component="button" onClick={toggle} id={`citation-ref-${id}`}>
          <sup>[{citationNumber}]</sup>
        </Link>
      )}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography component="p" variant="text">
          {publication}
          {'. '}
          <Link target="_blank" href={url}>
            {title}
          </Link>
          .
        </Typography>
        {accessDateFormatted ? (
          <Typography component="p" variant="text">
            {accessDateFormatted}
          </Typography>
        ) : null}
        <Typography component="p" variant="text">
          <Link
            href={`#${CITATION_LIST_ID}`}
            onClick={e => {
              e.preventDefault();

              scrollToCitationList();
            }}
          >
            View all sources
          </Link>
        </Typography>
      </Box>
    </DisclosureTooltip>
  );
};
